export type ToastType = "success" | "error" | "warning" | "info";

export class ToastConfig {
  show: boolean;
  title: string;
  message: string;
  type: ToastType;

  constructor(
    show = false,
    title = "",
    message = "",
    type: ToastType = "success"
  ) {
    this.show = show;
    this.title = title;
    this.message = message;
    this.type = type;
  }

  static success(title: string, message: string): ToastConfig {
    return new ToastConfig(true, title, message, "success");
  }

  static error(title: string, message: string): ToastConfig {
    return new ToastConfig(true, title, message, "error");
  }

  static hidden(): ToastConfig {
    return new ToastConfig();
  }
}
